import React from 'react';
import { ExternalLink, FileClock, Files, LogOut, Sparkles } from 'lucide-react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { useEngineSession } from '../features/session/EngineSessionProvider';
import { MAIN_BASE_URL } from '../shared/config/environment';

const EngineLayout: React.FC = () => {
  const location = useLocation();
  const session = useEngineSession();

  return (
    <div className="engine-app-shell">
      <header className="engine-app-header">
        <NavLink to="/documents" className="engine-app-brand" aria-label="云作引擎文档列表">
          <span className="engine-app-brand-mark"><Sparkles size={17} strokeWidth={2} /></span>
          <span>
            <strong>云作引擎</strong>
            <small>交付与审核</small>
          </span>
        </NavLink>

        <nav className="engine-app-nav" aria-label="主导航">
          <NavLink to="/documents" className={({ isActive }) => isActive ? 'is-active' : ''}>
            <Files size={16} />文档
          </NavLink>
          <NavLink to="/prototype" className={({ isActive }) => isActive ? 'is-active' : ''}>
            <FileClock size={16} />交互原型
          </NavLink>
        </nav>

        <div className="engine-app-header-actions">
          <a href={MAIN_BASE_URL} className="engine-app-quiet-link">
            返回云作平台<ExternalLink size={14} />
          </a>
          {session.status === 'authenticated' ? (
            <button type="button" className="engine-app-icon-button" onClick={() => void session.disconnect()} aria-label="退出引擎会话">
              <LogOut size={17} />
            </button>
          ) : location.pathname !== '/auth/callback' ? (
            <button type="button" className="engine-app-secondary-button" onClick={() => void session.startSignIn(location.pathname)}>
              连接账号
            </button>
          ) : null}
        </div>
      </header>
      <main className="engine-app-main">
        <Outlet />
      </main>
    </div>
  );
};

export default EngineLayout;
